import { createContext } from 'react';

export const ComponentSwitchContext = createContext<string | boolean | number | null>(null);
